import {html, LitElement} from 'lit';
import {customElement, property} from 'lit/decorators.js';
import {log} from '../controllers/LogController';
import DebugState from '../storage/DebugState';
import {ConfigurationState, IConfiguration} from '../storage/ConfigurationState';
import {SearchController} from '../controllers/SearchController';

// prevent tree shaking
export {};


@customElement('ca-configure')
export class CaConfigureElement extends LitElement {
  @property({type: Object})
  configuration!: IConfiguration;

  @property({attribute: 'debug', type: Boolean})
  isDebug: boolean = false;

  override connectedCallback() {
    log(this.constructor.name, 'connectedCallback');
    super.connectedCallback();

    window.suche4 = window.suche4 || {};
    window.suche4 = {
      configuration: ConfigurationState,
    };
    DebugState.isDebugJavaScript = this.isDebug;
    ConfigurationState.defaultPageTitle = document.title;
    ConfigurationState.defaultPageDescription = (
      <HTMLMetaElement | null>document.querySelector(
        'meta[name="description"]',
      )
    )?.content || '';
    ConfigurationState.configuration = this.configuration;
    SearchController.instance(
      this,
      'default',
      {
        json: ConfigurationState.resolve('../search/json'),
        geoJson: ConfigurationState.resolve('../search/geoJson'),
      },
    );
  }

  override render() {
    return html`
      <slot></slot>
    `;
  }
}
